import { render, staticRenderFns } from "./CommsInbox.vue?vue&type=template&id=47baab6a"
import script from "./CommsInbox.vue?vue&type=script&lang=js"
export * from "./CommsInbox.vue?vue&type=script&lang=js"
import style0 from "./CommsInbox.vue?vue&type=style&index=0&id=47baab6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports